// Module
var code = "<div class=\"dns-mx-record\"> <h3>MX Records</h3> <div class=\"clr-wrapper dns-mx-record__add-container\"> <button class=\"btn btn-primary\" ng-click=\"$ctrl.addMxRecord()\"> Add </button> </div> <grid config=\"::$ctrl.mxRecordsGridConfig\" rows=\"$ctrl.mxRecords\"></grid> </div> ";
// Exports
export default code;